import { cn } from '@ifixit/ui/lib/utils';
import { type ComponentProps } from 'react';

type AlertVariant = 'default' | 'warning' | 'critical' | 'info' | 'success';

// Spelled out as literals (not `alert-${variant}`) so Tailwind's content
// scanner sees each class and emits the matching @utility from alert.css.
const alertVariantClass: Record<AlertVariant, string> = {
   default: 'alert-default',
   warning: 'alert-warning',
   critical: 'alert-critical',
   info: 'alert-info',
   success: 'alert-success',
};

function Alert({
   className,
   variant = 'default',
   ...props
}: ComponentProps<'div'> & { variant?: AlertVariant }) {
   return (
      <div
         data-slot="alert"
         role="alert"
         className={cn(alertVariantClass[variant], className)}
         {...props}
      />
   );
}

function AlertTitle({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="alert-title" className={cn(className)} {...props} />;
}

function AlertDescription({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="alert-description" className={cn(className)} {...props} />;
}

export { Alert, AlertTitle, AlertDescription };
